/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'tls-fingerprint-match';
const prefix = `${moduleName}.${componentName}`;

export const fingerprintLabel = `${prefix}.fingerprintLabel`;

export const ENGLISH = {
    [fingerprintLabel]: 'Fingerprint',
};
